module.exports = __webpack_public_path__ + "static/media/icon.df93b45b.png";